export const isSandbox = () => {
  return ['sandbox'].includes(process.env.NEXT_PUBLIC_ENV_URL || '');
};
